module.exports = __webpack_public_path__ + "static/media/polo.4a30d9e2.png";